import { Scale } from "@pdfking/math"
import { PlotFunction } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Nelson, a square calendar: the year big in the middle of its picture; a month all picture, its name and grid on a card of paper at its foot, the logo beside it. */
export const Nelson: CalendarDesign = {
  cover: PictureCover({ at: 0.45, size: 0.16 }),
  page: ({ gap, labels, language, outer, page, short, year }, month) => {
    const card = Region(outer, 0, 0, 0.78, 0.45)
    return [
      // The card on the picture, clear round it
      Area.picture(page, month, false, [
        { enum: PlotFunction.PLOT_RECT, fill_color: PALETTE.paper, position: card },
      ]),
      ...Area.month(card, month, year, language, Scale(short, 0.06), gap),
      Area.logo(Region(outer, 0.84, 0.1, 1, 0.26), labels),
    ]
  },
  pages: "month",
}
